import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { apiGetProjects } from '../utils/api';

const ProjectsContext = createContext();

export const useProjects = () => useContext(ProjectsContext);

export const ProjectsProvider = ({ children }) => {
  const [projects, setProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(false);

  const loadProjects = useCallback(async () => {
    setLoadingProjects(true);
    try {
      const data = await apiGetProjects();
      if (data.success && Array.isArray(data.projects)) {
        setProjects(data.projects);
        localStorage.setItem('cachedProjects', JSON.stringify(data.projects));
      } else {
        const cached = localStorage.getItem('cachedProjects');
        setProjects(cached ? JSON.parse(cached) : []);
      }
    } catch {
      const cached = localStorage.getItem('cachedProjects');
      setProjects(cached ? JSON.parse(cached) : []);
    } finally {
      setLoadingProjects(false);
    }
  }, []);

  const refreshProjects = useCallback(() => {
    localStorage.removeItem('cachedProjects');
    loadProjects();
  }, [loadProjects]);

  // Загружаем проекты при старте
  useEffect(() => {
    loadProjects();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ProjectsContext.Provider value={{
      projects,
      loadingProjects,
      loadProjects,
      refreshProjects,
    }}>
      {children}
    </ProjectsContext.Provider>
  );
};